export const APP_NAME = "Webber Dynasty Photos";
